import Canvas from 'signer-app/signature-modal/draw/canvas';

export default Canvas;
